(function() {
	
	//Begin helper functions
	var addEvent = (function () {
	  if (document.addEventListener) {
	    return function (el, type, fn) {
	      if (el && el.nodeName || el === window) {
	        el.addEventListener(type, fn, false);
	      } else if (el && el.length) {
	        for (var i = 0; i < el.length; i++) {
	          addEvent(el[i], type, fn);
	        }
	      }
	    };
	  } else {
	    return function (el, type, fn) {
	      if (el && el.nodeName || el === window) {
	        el.attachEvent('on' + type, function () { return fn.call(el, window.event); });
	      } else if (el && el.length) {
	        for (var i = 0; i < el.length; i++) {
	          addEvent(el[i], type, fn);
	        }
	      }
	    };
	  }
	})();
	function getParentByTagName(o, t) {
		if (!o) return false;
		if (o.tagName == t) return o;
		else return getParentByTagName(o.parentNode, t);
	}
	function nextObject(e) {
		do e = e.nextSibling;
		while (e && e.nodeType != 1);
		return e;
	}
	function prevObject(e) {
		do e = e.previousSibling;
		while (e && e.nodeType != 1);
		return e;
	}
	function parseJSON(text) {
		return eval('('+text+')');
	}
	function toCurrency(price) {
		if (price < 10) {
			price = '00' + price;
		} else if (price < 100) {
			price = '0' + price;			
		}
		price = price + '';
		var currency = document.getElementById('summary-total').innerHTML.replace(/[0-9\.,]/g, ''),
		    units = price.substring(0, price.length - 2),
			decimals = price.substring(price.length - 2, price.length);
		var format = /(\d+)(\d{3})/;
		while (format.test(units)) {
			units = units.replace(format, '$1' + ',' + '$2');
		}
		return currency + units + '.' + decimals;
	}
	function pluralize(text, number) {
		if (parseInt(number) == 1) {
			return number + ' ' + text;
		} else {
			return number + ' ' + text + 's';
		}
	}
	function updateSummary(response) {
		if (response) {
			var price = toCurrency(response.total_price),
				summary = document.getElementById('cart-summary');
			document.getElementById('summary-total').innerHTML = price;
			document.getElementById('summary-items').innerHTML = pluralize('item', response.item_count);
			if (response.item_count == 0) {
				summary.className = summary.className.replace(' active', '');
			} else if (summary.className.indexOf('active') == -1) {
				summary.className += ' active';
			}
			if (document.getElementById('cart-total')) {
				document.getElementById('cart-total').innerHTML = price;
			}
		} else {
			if (window.XMLHttpRequest) {
				var request = new XMLHttpRequest();
				request.onreadystatechange = function() {
					if (request.readyState == 4 && request.status == 200) {
						var response = parseJSON(request.responseText);
						updateSummary(response);
				    }
				}
				request.open('GET','/cart.js',true);
				request.send();
			}
		}
	}
	function documentWidth() {
		if (window.innerWidth) {
			return window.innerWidth;
		} else if(document.documentElement) {
			return document.documentElement.clientWidth;
		} else {
		 	return document.body.clientWidth;
		}
	}
	function addIncrements(el) {
		var minus = document.createElement('a'),
			plus = document.createElement('a');
		minus.href = plus.href = '#'
		minus.className = 'quantity-minus button';
		minus.innerHTML = '&minus;';
		plus.className = 'quantity-plus button';
		plus.innerHTML = '+';
		minus.onclick = function() {
			if (parseFloat(el.value) != 1) {
				el.value = parseFloat(el.value) - 1;
				if (document.getElementById('cart-form')) {
					var i = el.id.replace('quantity-', '');
					adjustQuantity(el.value, i);
				}
			}
			return false;
		}
		plus.onclick = function() {
			el.value = parseFloat(el.value) + 1;
			if (document.getElementById('cart-form')) {
				var i = el.id.replace('quantity-', '');
				adjustQuantity(el.value, i);
			}
			return false;
		}
		el.parentNode.insertBefore(minus, el);
		el.parentNode.insertBefore(plus, el.nextSibling);
	}
	//End helper functions
	
	// Create a show/hide menu if the screen is narrow.
	// (function() {
	// 	function createNavToggle() {
	// 		var nav = document.getElementById('collection-nav'),
	// 			navToggle = document.createElement('a'),
	// 			cartSummary = document.getElementById('cart-summary');
	// 		nav.className += ' hide'
	// 		navToggle.className = 'nav-toggle';
	// 		navToggle.innerHTML = 'Menu';
	// 		navToggle.href = '#';
	// 		navToggle.onclick = function(e) {
	// 			if (nav.className.indexOf('hide') == -1) {
	// 				nav.className += ' hide';						
	// 			} else {
	// 				nav.className = nav.className.replace(' hide', '');
	// 			}
	// 			return false;
	// 		}
	// 		nav.parentNode.insertBefore(navToggle, nav);
	// 	}
	// 	function createSearchToggle() {
	// 		var search = document.getElementById('search'),
	// 			cartSummary = document.getElementById('cart-summary'),
	// 			searchLink = document.createElement('a');
	// 		if (search.getElementsByTagName('input')[0].value == '') {
	// 			search.className += ' hide';
	// 		}
	// 		searchLink.className = 'search-toggle';
	// 		searchLink.innerHTML = 'Search';
	// 		searchLink.href = '#';
	// 		searchLink.onclick = function(e) {
	// 			if (search.className.indexOf('hide') == -1) {
	// 				search.className += ' hide';						
	// 			} else {
	// 				search.className = search.className.replace(' hide', '');
	// 			}
	// 			return false;
	// 		}
	// 		cartSummary.parentNode.insertBefore(searchLink, cartSummary);
	// 	}
	// 	function createListToggle() {
	// 		var list = document.getElementById('collection-list'),
	// 			listToggle = document.createElement('p'),
	// 			listToggleLink = document.createElement('a');
	// 		list.className += ' hide'
	// 		listToggle.className = 'list-toggle';
	// 		listToggleLink.innerHTML = 'Choose Category or Subcategory&hellip;';
	// 		listToggleLink.href = '#';
	// 		listToggleLink.onclick = function(e) {
	// 			if (list.className.indexOf('hide') == -1) {
	// 				list.className += ' hide';						
	// 			} else {
	// 				list.className = list.className.replace(' hide', '');
	// 			}
	// 			return false;
	// 		}
	// 		listToggle.appendChild(listToggleLink);
	// 		list.parentNode.insertBefore(listToggle, list);
	// 	}
	// 	createNavToggle();
	// 	createSearchToggle();
	// 	if (document.getElementById('collection-list')) {
	// 		createListToggle();
	// 	}
	// })();	
	
	//Carousel interaction
	// (function() {
	// 	if (document.getElementById('carousel-nav')) {
	// 		var slides = document.getElementById('carousel-images'),
	// 			slidesItems = slides.getElementsByTagName('li'),
	// 			nav = document.getElementById('carousel-nav'),
	// 			navItems = nav.getElementsByTagName('li'),
	// 			current = 0;
	// 		
	// 		function showSlide(i) {
	// 			if (i != current && slidesItems[i]) {
	// 				slide = slidesItems[i];
	// 				slide.className += ' show';
	// 				setTimeout (function() {
	// 					slide.className = slide.className.replace('show', 'appear');					
	// 				}, 1);
	// 				setTimeout(function() {
	// 					slidesItems[current].className = slidesItems[current].className.replace('current', '');
	// 					slide.className = slide.className.replace('appear', 'current');
	// 					current = i;
	// 				}, 300);
	// 				navItems[i+1].className += ' current';
	// 				navItems[current+1].className = navItems[current+1].className.replace('current', '');
	// 				if (i == 0) {
	// 					if (navItems[0].className.indexOf('disabled') == -1) {
	// 						navItems[0].className += ' disabled';
	// 					}
	// 				} else {
	// 					navItems[0].className = navItems[0].className.replace(' disabled', '');
	// 				}
	// 				var l = navItems.length - 1;
	// 				if (i == slidesItems.length - 1) {
	// 					if (navItems[l].className.indexOf('disabled') == -1) {
	// 						navItems[l].className += ' disabled';
	// 					}
	// 				} else {
	// 					navItems[l].className = navItems[l].className.replace(' disabled', '');
	// 				}
	// 			}
	// 		}	
	// 		
	// 		nav.onclick = function(e) {
	// 			e = e || window.event; e = e.target || e.srcElement;
	// 			e = getParentByTagName(e, 'A');
	// 			if (e) {
	// 				var action = e.getAttribute('data-action');
	// 				if (action == 'prev') {
	// 					showSlide(current - 1);
	// 				} else if (action == 'next') {
	// 					showSlide(current + 1);
	// 				} else {
	// 					showSlide(parseInt(action));
	// 				}
	// 			}
	// 			return false;
	// 		}
	// 	}
	// })();
	
	//Quantity increments
	(function() {
		if (document.getElementById('quantity')) {
			var quantity = document.getElementById('quantity');
			addIncrements(quantity);
		}
		if (document.getElementById('cart-form')) {
			var form = document.getElementById('cart-form'),
			    inputs = form.getElementsByTagName('input');
			for (i=0; i<inputs.length; i++) {
				if (inputs[i].className.indexOf('quantity') !== -1) {
					addIncrements(inputs[i]);
				}
			}
		}
	})();
	
	//Add to cart button
	(function() {
		var added = false;
		if (document.getElementById('add-to-cart')) {
			var error = false,
				cart = document.getElementById('cart-summary'),
				add = document.getElementById('add'),
				message = document.createElement('div'),
				timer;
			message.className = 'message';

			function messageTimer() {
				clearTimeout(timer);
				timer = setTimeout(function() {
					message.style.opacity = 0;
					setTimeout(function(){
						cart.removeChild(message);
					}, 300);
				}, 10000);
			}

			function addToCart(q, i) {
				if (window.XMLHttpRequest && !added) {
					var request = new XMLHttpRequest();
					request.onreadystatechange = function() {
						if (request.readyState == 4 && request.responseText) {
							if (request.status == 200) {
								var response = parseJSON(request.responseText);
								updateSummary();
								message.className = message.className.replace(' loading', '');
								message.innerHTML = '<span>'+response.title+'</span> added to your cart!';
								cart.appendChild(message);
								setTimeout(function() {
									message.style.opacity = 1;					
								}, 10);
								window.scrollTo(0,0);
								messageTimer();
								add.disabled = false;
							} else if (request.status == 500) {
								add.disabled = false;
								var response = parseJSON(request.responseText);
								alert(response.description);
							} else {
								add.disabled = false;
								error = true;
								document.getElementById('add-to-cart').submit();
							}
					    }
					}
					request.open('POST','/cart/add.js?quantity='+q+'&id='+i,true);
					request.send();
					added = true;
					return true;
				}
				return false;
			};

			if (document.getElementById('add-to-cart')) {
				document.getElementById('add-to-cart').onsubmit = function(e) {
					if (error != true) {
						add.disabled = true;
						// Since we disabled the QTY field we have to comment this and set it manually to 1
						// q = document.getElementById('quantity').value;
						q = 1;
						v = document.getElementById('variant').value;
						if (addToCart(q, v)) {
							return false;
						}
					}
					return true;
				}
			}
		}

	})();
	
	//Cart form interactions
	(function() {
		if (document.getElementById('cart-form')) {
			var form = document.getElementById('cart-form'),
				tbody = form.getElementsByTagName('tbody')[0],
			    rows = tbody.getElementsByTagName('tr');
			
			document.getElementById('update-cart').style.display = 'none';
				
			window.adjustQuantity = function(q, i) {
				if (window.XMLHttpRequest) {
					var request = new XMLHttpRequest();
					request.onreadystatechange = function() {
						if (request.readyState == 4 && request.responseText) {
							if (request.status == 200) {
								var response = parseJSON(request.responseText);
								if (q == 0) {
									var item = document.getElementById('cart-item-'+i)
									item.parentNode.removeChild(item);
								} else {
									var items = response.items;
									var itemTotal = document.getElementById('cart-item-'+i+'-total');
									for (j=0; j<items.length; j++) {
										if (items[j].id == i) {
											itemTotal.innerHTML = toCurrency(items[j].line_price);
											break;
										}
									}
								}
								updateSummary(response);
							} else if (request.status == 500) {
								var response = parseJSON(request.responseText);
								alert(response.description);
							} else {
								document.getElementById('cart-form').submit();
							}
					    }
					}
					request.open('POST','/cart/change.js?quantity='+q+'&id='+i,true);
					request.send();
					return true;
				}
				return false;
			};
			
			function removeItem(i) {
				document.getElementById('quantity-'+i).val = 0;
				if (!adjustQuantity(0, i)) {
					document.getElementById('cart-form').submit();
				}
			}
			
			for (i=0; i<rows.length; i++) {
				var variant = rows[i].id.replace('cart-item-', ''),
					cell = rows[i].getElementsByTagName('td')[0],
					product = cell.getElementsByTagName('a')[0],
					title = product.innerText? product.innerText : product.textContent,
					remove = document.createElement('a');
				remove.className = 'remove';
				remove.href = '#';
				remove.innerHTML = 'Remove';
				remove.setAttribute('data-remove', variant);
				remove.onclick = function() {
			        var message = 'Are you sure you want to remove "'+title+'" from your cart?';
			        if (confirm(message)) { 
						removeItem(this.getAttribute('data-remove'));
			        }
			        return false;
				}
				cell.appendChild(remove);
			}
			addEvent(tbody, 'input', function(e) {
				e = e || window.event; e = e.target || e.srcElement;
				e = getParentByTagName(e, 'INPUT');
				if (e && e.className.indexOf('quantity') !== -1) {
					var q = e.value;
					var i = e.id.replace('quantity-', '');
					adjustQuantity(q, i);
				}
			});
		}
	})();

	(function() {
		if (document.getElementById('product')) {
			var p = document.getElementById('product'),
				b = document.getElementById('large-image'),
				i = b.getElementsByTagName('img')[0],
				l = document.getElementById('product-image-list');
				if (l) {
					var a = l.getElementsByTagName('a');
				}

			i.onload = function(e) {
				var p = this.parentNode;
				p.className = p.className.replace(' loading', '');
			};

			// if (window.innerWidth && window.innerWidth > 640) {
			// 	var s = document.createElement('span');
			// 	s.className = 'enlarge-icon';
			// 	// s.innerHTML = 'View Large Image';
			// 	s.innerHTML = '';
			// 	b.appendChild(s);
			// 	b.className += ' action';
			// 	b.onclick = function(e) {
			// 		e = e || window.event; e = e.target || e.srcElement;
			// 		e = getParentByTagName(e, 'DIV');
			// 		if (e) {
			// 			if (p.className.indexOf('enlarged') !== -1) {
			// 				e.className += ' loading';
			// 				p.className = p.className.replace(' enlarged', '');
			// 				i.src = i.src.replace('grande', 'large');
			// 				s.innerHTML = 'View Large Image';
			// 			} else {
			// 				e.className += ' loading';
			// 				i.src = i.src.replace('large', 'grande');
			// 				p.className += ' enlarged';
			// 				s.innerHTML = 'View Smaller Image';
			// 			}
			// 		}
			// 	}
			// }

			if (l) {
				l.onclick = function(e) {
					e = e || window.event; e = e.target || e.srcElement;
					e = getParentByTagName(e, 'A');
					if (e && e.className != 'current') {
						b.className += ' loading';
						var u = e.href;
						if (p.className.indexOf('enlarged') === -1) {
							u = u.replace('grande', 'large');
						}
						i.src = u;
						for (var j=0; j<a.length; j++) {
							if (a[j].className.indexOf('current') != -1) {
								a[j].className = a[j].className.replace('current', '');
							}
						}
						e.className = 'current';
					}
					return false;
				};
			}
		}
	})();

	//Product tabs interaction
	(function() {
		if (document.getElementById('product-tabs')) {
			var t = document.getElementById('product-tabs');
			var l = t.getElementsByTagName('a');
			var d = document.getElementById('details');
			var h = document.getElementById('tab-page');
			if (t && d && h) {
				var o = d.innerHTML;
				t.onclick = function(e) {
					e = e || window.event; e = e.target || e.srcElement;
					e = getParentByTagName(e, 'A');
					if (e) {
						for (i=0; i<l.length; i++) {
							l[i].className = l[i].className.replace('current', '');
						}
						if (e.className .indexOf('current') == -1) {
							e.className += ' current';
							if (e.className .indexOf('product-details') !== -1) {
								h.style.display = 'none';
								d.style.display = 'block';
							} else {
								d.style.display = 'none';
								h.style.display = 'block';
							}
						}
						return false;
					}
				}
			}
		}
	})();
})();